import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
// import Navbar from "../component/Navbar/Navbar";

// components
import StepIndicator from "../components/StepIndicator";

// helper
import { getReservation } from "../helpers/localStorage";

// icon
import { CalendarDaysIcon, UserIcon, ChatBubbleBottomCenterTextIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { Ireservation } from "../helpers/interfaces";

export function mainLayoutLoader() {
  return getReservation();
}

interface Props { }
const MainLayout: React.FC<Props> = () => {

  const reservation = useLoaderData() as Ireservation;

  const checkStatus = (path: 'step1' | 'step2' | 'step3' | 'step4'): 'waiting' | 'done' | 'error' | 'current' | 'disabled' => {
    if (path === 'step1') {
      // return 'error';
      if(!reservation.people || !reservation.service || !reservation.date) return 'waiting';
      if(!!reservation.people && !!reservation.service && !!reservation.date) return 'done';
    }
    if (path === 'step2'){
      if(!reservation.people || !reservation.service || !reservation.date) return 'disabled';
      if(!reservation.firstName || !reservation.lastName || !reservation.phone || !reservation.email || !reservation.emailCheck) return 'waiting';
      if(!!reservation.firstName && !!reservation.lastName && !!reservation.phone && !!reservation.email && !!reservation.emailCheck) return 'done';
    }
    
    if (path === 'step3'){
      if(!reservation.people || !reservation.service || !reservation.date) return 'disabled';
      if(!reservation.firstName || !reservation.lastName || !reservation.phone || !reservation.email || !reservation.emailCheck) return 'disabled';
      if(!reservation.gdpr) return 'waiting';
      if(reservation.gdpr) return 'done';
      return 'done';
    }

    if (path === 'step4'){
      if(!reservation.gdpr) return 'disabled';
      return 'waiting';
      // if(!reservation.firstName || !reservation.lastName || !reservation.phone || !reservation.email || !reservation.emailCheck) return 'disabled';
      // if(!reservation.gdpr || !reservation.mailingList) return 'waiting';
      // if(!!reservation.gdpr && !!reservation.mailingList) return 'done';
      // return 'done';
    }
    return 'disabled';
  }

  return (
    <div className="main-layout">

      <main>

        <h1>{reservation.status === 'pending' ? 'Richiesta di prenotazione' : 'Lista d\'attesa'} </h1>

        <StepIndicator steps={[          
          { name: 'Reservation', path: '/', status: checkStatus('step1'), svg: <CalendarDaysIcon className="w-6 h-6" width={50} /> },
          { name: 'Customer', path: '/step2', status: checkStatus('step2'), svg: <UserIcon className="w-6 h-6" width={50} /> },
          { name: 'Comunication', path: '/step3', status: checkStatus('step3'), svg: <ChatBubbleBottomCenterTextIcon className="w-6 h-6" width={50} /> },
          { name: 'Confirm', path: '/step4', status: checkStatus('step4'), svg: <CheckCircleIcon className="w-6 h-6" width={50} /> },
        ]} />

        <Outlet />
      </main>
    </div>
  );
};
export default MainLayout;
